import { buildQueryHelpers, OperationIds } from '../../util'
import { createViewForBlockConnectorCandidate } from './cacheTransformFns/createViewForBlockConnectorCandidate'
import { readBlockConnectorCandidates as readBlockConnectorCandidateCollection } from './requests'
import { BlockConnectorCandidatesKey } from './types'
import { useReadBlockConnectorCandidates } from './useReadBlockConnectorCandidates'

export type { BlockConnectorCandidatesResponse } from './types'
export * from './utils'
export const blockConnectorCandidates = {
  readCollection: readBlockConnectorCandidateCollection,
}

export const readBlockConnectorCandidates = {
  ...buildQueryHelpers<
    OperationIds.ReadBlockConnectorCandidatesBFFV1,
    BlockConnectorCandidatesKey
  >('block', OperationIds.ReadBlockConnectorCandidatesBFFV1),
  queryIdentifiers: (
    workspaceUuid: string,
    blockId: string,
    allBlocks?: boolean
  ): BlockConnectorCandidatesKey => ({
    workspaceUuid,
    resourceId: blockId,
    queryParams: {
      all_blocks: allBlocks,
    },
  }),
  useQuery: useReadBlockConnectorCandidates,
  transformCache: {
    createViewForBlockConnectorCandidate,
  },
}
